import { render, staticRenderFns } from "./ObjectGallery.vue?vue&type=template&id=55a8362f&scoped=true&"
import script from "./ObjectGallery.vue?vue&type=script&lang=js&"
export * from "./ObjectGallery.vue?vue&type=script&lang=js&"
import style0 from "./ObjectGallery.vue?vue&type=style&index=0&id=55a8362f&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "55a8362f",
  null
  
)

export default component.exports